<template>
<Dialog :header="header" 
v-model:visible="show_modal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '80vw'}"
:modal="true"
>

<div class="grid mt-4" v-if="item">
<div class="col-12">
<span class="p-float-label mb-4 mt-0" >
  <InputText :id="'name_'" type="text" v-model="item.name" class="w-full p-inputtext-sm" />
  <label :for="'name_'" >Şablon İsmi</label>
</span>
</div>
</div>

<Fieldset v-for="(translation,index) in item.translations" :legend="translation.language.name"  :toggleable="true" class="mt-2 mb-2" :collapsed="true" >

<div class="grid" >

<div class="col-12">
<h4 class="text-primary">{{translation.language.name}}</h4>
</div>
<div class="col-12">
<span class="p-float-label mb-4 mt-0" >
  <InputText :id="'title_'+index" type="text" v-model="item.translations[index].title" class="w-full p-inputtext-sm" />
  <label :for="'title_'+index" >Başlık</label>
</span>
</div>


<div class="col-12">
<Editor v-model="item.translations[index].content" 
editorStyle="height: 260px"
@text-change="updateInput($event,index)"
>

<template #toolbar>
<span class="ql-formats">
    <select class="ql-header" defaultValue="0">
        <option value="1">Heading</option>
        <option value="2">Subheading</option>
        <option value="0">Normal</option>
    </select>
</span>
<span class="ql-formats">
  <button class="ql-bold"></button>
  <button class="ql-italic"></button>
  <button class="ql-underline"></button>
</span>
 <span class="ql-formats">
    <button class="ql-list" value="ordered" type="button"></button>
    <button class="ql-list" value="bullet" type="button"></button>
    <select class="ql-align">
        <option defaultValue></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
    </select>
</span>
 <span class="ql-formats">
    <button class="ql-link" type="button"></button>
</span>
<span class="ql-formats">
 <button class="ql-custom_link text-primary" type="button" >Flow Page</button>
</span>


  </template>

</Editor>
</div>


</div>

</Fieldset>



<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="hideModal" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>

<Button :label="$store.state.languages.lang_phrases.kaydet" icon="pi pi-check" @click="submit"  class=" p-button-primary p-button-outlined  p-button-sm"  :loading="submitting"/>

</template>

</Dialog>	
</template>

<script>
export default {

  name: 'FlowMailTemplateModal',
  props:["languages","mailtemplate"],
  data () {
    return {
    	show_modal:false,
    	submitting:false,
    	item:null,
    }
  },
  computed:{
  	header()
  	{
  		if(this.item && this.item.id)
  		{
  			return this.item.name
  		}
  		else
  		{
  			return "Yeni Email Şablonu"
  		}
  		
  	},
  },
  methods:{
  	updateInput(event,index)
  	{
  		console.log(event)
  		console.log(index)
  		this.item.translations[index].content = event.htmlValue
  	},
  	showModal()
  	{
  		this.item = this.mailtemplate
  		this.show_modal = true
  		
  	},
  	hideModal()
  	{
  		this.show_modal = false
  	},
  	submit()
  	{
  		console.log(this.item)
  		console.log(this.$store.state.flows.flow.brand_id)
  		//return false
  		let formdata = new FormData()
  		formdata.append('brand_id', this.$store.state.flows.flow.brand_id);
  		formdata.append('item', JSON.stringify(this.item));
  		if(this.item.id)
  		{
  			this.generalSubmission(formdata,"mailtemplate/update/"+this.item.id,this.afterSubmit)
  		}
  		else
  		{
  			this.generalSubmission(formdata,"mailtemplate/store",this.afterSubmit)
  		}
  		
  	},
  	afterSubmit(response)
  	{
  		console.log(response.data)
  		this.hideModal()
  		this.$emit("newMailTemplateSubmitted",response.data)
  	},
  }
}
</script>

<style lang="css" scoped>
</style>